import apiService from './apiService';

export default class DashboardWidgetApiService {
    /**
     * Get the Dashboard Widgets for the user
     * @return {Promise<ServiceResponse<Array<DashboardWidgetDto>>>}
     */
    async getDashboardWidgets() {
        const response = await apiService.getData('api/DashboardWidget');

        return response.data;
    }

    /**
     * Post all dashboard widgets
     *
     * @param dashboardWidgets {List<DashboardWidgetDto>}
     * @return {Promise<ServiceResponse<Boolean>>}
     */
    async postDashboardWidgets(dashboardWidgets) {
        const response = await apiService.postData('api/DashboardWidget', dashboardWidgets);

        return response.data;
    }

    /**
     * Delete a dashboard widget
     *
     * @param dashboardWidgetId {number}
     * @return {Promise<ServiceResponse<Boolean>>}
     */
    async deleteDashboardWidgets(dashboardWidgetId) {
        const response = await apiService.deleteData('api/DashboardWidget/' + dashboardWidgetId);

        return response.data;
    }
}
